import Vue from 'vue';
import { DirectiveBinding } from 'vue/types/options';
import { customerService } from '@/services/customer/customer.service';

Vue.directive('fetch-user', {
  bind: async function (el: HTMLElement, binding: DirectiveBinding) {
    el.innerText = '......';
    let fullName = `Customer: ${binding.value} [INACTIVE]`;
    try {
      const customer = await customerService.get(binding.value);
      fullName = `${customer.firstName} ${customer.lastName}`;
    } catch (_) {}

    el.innerText = fullName;
  },
});
